// extracted by mini-css-extract-plugin
export default {"viewed":"MarkAsViewedButton-module__viewed--czELS","iconOnly":"MarkAsViewedButton-module__iconOnly--tQ1ah"};